import { Loader } from "@circle-react-uikit/Loader";
import { CursorPagination } from "./CursorPagination";

export interface TwoWayPaginationProps {
  children: React.ReactNode;
  componentId: string;
  firstItemId: any;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  isLoading: boolean;
  lastItemId: any;
  onNextPage: (messageId: number | null) => Promise<void> | void;
  onPrevPage: (messageId: number | null) => Promise<void> | void;
  shouldShowNextLoader?: boolean;
  shouldShowPrevLoader?: boolean;
}

export const TwoWayPagination = ({
  children,
  shouldShowPrevLoader = true,
  shouldShowNextLoader = true,
  hasNextPage,
  hasPrevPage,
  onPrevPage,
  onNextPage,
  firstItemId,
  lastItemId,
  componentId,
  isLoading,
}: TwoWayPaginationProps) => (
  <div id={componentId} className="overflow-auto pt-2">
    {isLoading
      ? shouldShowPrevLoader && <Loader center />
      : hasPrevPage && (
          <CursorPagination
            componentId={componentId}
            fetchNewPage={onPrevPage}
            onEvent="scrollUp"
            messageId={firstItemId}
            isLoading={isLoading}
          />
        )}
    {children}
    {isLoading
      ? shouldShowNextLoader && <Loader center />
      : hasNextPage && (
          <CursorPagination
            componentId={componentId}
            fetchNewPage={onNextPage}
            messageId={lastItemId}
            footerDistanceFromBottom={-500}
            isLoading={isLoading}
          />
        )}
  </div>
);
